import React from 'react';
import { Modal, Box, IconButton, SxProps, Theme } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import styles from '../../../index.module.scss';

interface BaseModalProps {
  open: boolean;
  handleClose: () => void;
  children: React.ReactNode;
  width?: number | string;
  minWidth?: number | string;
  maxWidth?: number | string;
  height?: number | string;
  minHeight?: number | string;
  maxHeight?: number | string;
  sx?: SxProps<Theme>;
}

const BaseModal: React.FC<BaseModalProps> = ({
  children,
  open,
  handleClose,
  width = 400,
  minWidth,
  maxWidth,
  height,
  minHeight,
  maxHeight,
  sx,
}) => (
  <Modal open={open} onClose={handleClose}>
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width,
        minWidth,
        maxWidth,
        height,
        minHeight,
        maxHeight,
        bgcolor: styles.lightGrey,
        boxShadow: 24,
        p: 4,
        alignItems: 'center',
        textAlign: 'center',
        borderRadius: '0.5rem',
        ...sx,
      }}
    >
      <IconButton onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
        <HighlightOffIcon />
      </IconButton>
      {children}
    </Box>
  </Modal>
);

export default BaseModal;
